export const BASE_URL = import.meta.env.VITE_API_HOST;
export const DEFAULT_LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL;
export const IS_PROD = import.meta.env.PROD;
export const STRIPE_PUBLIC_KEY = import.meta.env.VITE_STRIPE_PUBLIC_KEY;
export const CRISP_WEBSITE_ID = import.meta.env.VITE_CRISP_WEBSITE_ID;
// Displayed price of an additional licence, in cents per month (×10 when
// billed annually) — must match the Stripe per-seat prices
export const ADDITIONAL_LICENCE_MONTHLY_PRICES: Record<
  "company" | "support",
  number
> = {
  company: 20 * 100,
  support: 30 * 100,
};
